import * as React from 'react';
import * as styles from './FixedPanel.css';

interface IProps {
  children: React.ReactNode;
}

export function FixedPanel({ children }: IProps) {
  const containerRef = React.useRef<HTMLDivElement | null>(null);
  const panelRef = React.useRef<HTMLDivElement | null>(null);
  const [containerWidth, setContainerWidth] = React.useState(0);
  const [isFixed, setIsFixed] = React.useState(false);
  const [containerOffset, setContainerOffset] = React.useState(0);

  const handleResize = () => {
    if (containerRef && containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }
  };

  const handleScroll = () => {
    if (!containerRef || !containerRef.current) {
      return;
    }

    const scrollY = window.scrollY;
    const offset = scrollY + containerRef.current.getBoundingClientRect().top;

    setIsFixed(scrollY >= offset);
  };

  React.useEffect(() => {
    handleResize();
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  React.useEffect(() => {
    if (containerRef && containerRef.current && containerRef.current.offsetWidth !== containerWidth) {
      setContainerWidth(containerRef.current.offsetWidth);
    }
  });

  React.useEffect(() => {
    if (panelRef && panelRef.current && panelRef.current.offsetHeight !== containerOffset) {
      const panelHeight = panelRef.current.offsetHeight;
      setContainerOffset(panelHeight);
    }
  });

  return (
    <div className={styles['container']} ref={containerRef} style={{ paddingTop: containerOffset }}>
      <div
        className={isFixed ? styles['container-fixed'] : styles['container-static']}
        style={{ width: containerWidth }}
        ref={panelRef}
      >
        {children}
      </div>
    </div>
  );
}
